import React from 'react';
import DirectorySection from '../directory/DirectorySection';
import { useLocale } from '../../context/LocaleContext';
import { t } from '../../utils/i18n';

interface FoodInfoProps {
  food?: string;
  pricePerMeal?: string;
  tips?: string;
  notification?: string;
  findLocalFood?: string;
  className?: string;
}

const FoodInfo: React.FC<FoodInfoProps> = ({
  food,
  pricePerMeal,
  tips,
  notification,
  findLocalFood,
  className = '',
}) => {
  const { locale } = useLocale();
  if (!food && !pricePerMeal && !tips && !notification && !findLocalFood) {
    return null;
  }

  return (
    <DirectorySection
      title={t(locale, 'localFood')}
      icon="🍽️"
      className={className}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="space-y-4">
          {food ? (
            <div>
              <h3 className="text-sm font-semibold mb-2">{t(locale, 'localSpecialties')}</h3>
              <p className="text-sm text-[var(--dir-muted)] leading-relaxed">{food}</p>
            </div>
          ) : null}
          {pricePerMeal ? (
            <div>
              <h3 className="text-sm font-semibold mb-2">{t(locale, 'mealPrice')}</h3>
              <p className="text-sm text-[var(--dir-muted)]">{pricePerMeal}</p>
            </div>
          ) : null}
        </div>
        <div className="space-y-4">
          {tips ? (
            <div>
              <h3 className="text-sm font-semibold mb-2">{t(locale, 'tippingCulture')}</h3>
              <p className="text-sm text-[var(--dir-muted)] leading-relaxed">{tips}</p>
            </div>
          ) : null}
          {notification ? (
            <div>
              <h3 className="text-sm font-semibold mb-2">{t(locale, 'importantNotice')}</h3>
              <p className="text-sm text-[var(--dir-muted)] leading-relaxed">{notification}</p>
            </div>
          ) : null}
          {findLocalFood ? (
            <div>
              <h3 className="text-sm font-semibold mb-2">{t(locale, 'findAuthenticFood')}</h3>
              <p className="text-sm text-[var(--dir-muted)] leading-relaxed">{findLocalFood}</p>
            </div>
          ) : null}
        </div>
      </div>
    </DirectorySection>
  );
};

export default FoodInfo;
